import { useAuth } from '../context/AuthContext'
import { t, tEn } from '../i18n/translations'

// "Free Trial — 12 days remaining", and nothing else.
//
// Shown only while a trial is actually what is granting access. A subscriber
// or a lifetime teacher must never see it, and neither must someone whose
// trial has ended — for them the invitation lives in the locked-lesson dialog,
// where it is in context rather than following them around the app.
export default function TrialStatus() {
  const { onFreeTrial, premiumDaysRemaining } = useAuth()
  if (!onFreeTrial || premiumDaysRemaining === null) return null

  const label = premiumDaysRemaining === 1
    ? t('trialLastDay')
    : `${t('trialBadge')} — ${premiumDaysRemaining} ${t('trialDaysRemaining')}`

  return (
    <div className="trial-status" role="status" title={tEn('trialBadge')}>
      {label}
    </div>
  )
}
